var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.81 140.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bfda0fca-dc57-4154-bf93-2450d0b3c679{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f47a227d-0926-4cb9-8e31-d8fdfc5b44e4",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bfda0fca-dc57-4154-bf93-2450d0b3c679",
    d: "M6.23,134.58l39.28,0a3.62,3.62,0,0,0,1.82-.49l29.84-17.22a2.51,2.51,0,0,0,0-4.35L56,100.28a3.65,3.65,0,0,1-1.83-3.16v-56A3.65,3.65,0,0,1,56,37.94l54.6-32.51"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.a757f08b.svg";
export { ForwardRef as ReactComponent };